import { render, staticRenderFns } from "./PageBlock.vue?vue&type=template&id=04d7caa0&scoped=true&"
import script from "./PageBlock.vue?vue&type=script&lang=js&"
export * from "./PageBlock.vue?vue&type=script&lang=js&"
import style0 from "./PageBlock.vue?vue&type=style&index=0&id=04d7caa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7caa0",
  null
  
)

export default component.exports